import React from 'react';
import UnitSlideShowCard from '../UnitSlideShowCard/UnitSlideShowCard';
import type { SlideShow } from '../UnitSlideShowCard/UnitSlideShowCardTypes';

interface UnitSlideShowCardsProps {
  programId: number;
  slideShows: SlideShow[];
  unitColor: string;
  unitId: number;
}

const UnitSlideShowCards = ({ programId, slideShows, unitColor, unitId }: UnitSlideShowCardsProps) => (
  <div className="tw-flex tw-flex-col tw-px-8">
    {slideShows.map(ss => (
      <UnitSlideShowCard
        key={ss.id}
        programId={programId}
        slideShow={ss}
        unitColor={unitColor}
        unitId={unitId}
      />
    ))}
  </div>
);

export default UnitSlideShowCards;
